/* eslint-disable jsx-a11y/no-static-element-interactions */
/*
 * Created Date: 28-02-2024, 8:42:36 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Thu Mar 21 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */
import { studioColor } from '@App/Studio/app-config/theme'
import { footerNavigationConfig } from '@App/Studio/appConfig'
import { useCoreAuth } from '@Core/Provider/CoreAuthProvider'
import { useBreakpoints } from '@Core/hooks'
import { useLayoutContext } from '@App/Studio/Layout'
import clsx from 'clsx'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { FaAngleLeft, FaSortDown } from 'react-icons/fa'
import { Menu, MenuItem, Sidebar, SubMenu } from 'react-pro-sidebar'
import { useLocation } from 'react-router-dom'
import { useCorePlanContext } from '@Core/Provider/CorePlanProvider'
import { useCoreWorkspaceContext } from '@Core/Provider/CoreWorkspaceProvider'
import { Divider, Typography } from '@mui/material'
import { useCoreContactContext } from '@Core/Provider/CoreContactProvider'
import MenuTypeItem from './components/MenuType/MenuTypeItem'
import MenuTypeGroup from './components/MenuType/MenuTypeGroup'
import { isFunction } from 'lodash'
import LogoStudio from '../LogoStudio'

const SidebarContentV2 = props => {
	const { t } = useTranslation()
	const { user } = useCoreAuth()
	const { currentWorkspace } = useCoreWorkspaceContext()
	const { currentPlan } = useCorePlanContext()
	// console.log('============= currentWorkspace', currentWorkspace)
	const location = useLocation()
	// const matches = useMatches()
	// console.log('============= matches', matches)
	const { desktop, laptop, mobile } = useBreakpoints()

	const { layout, layoutConfig, toggleCollapse, toggleOpenMobileSidebar, appNavigationConfig } = useLayoutContext()
	const contactContext = useCoreContactContext()
	// console.log('🚀 ~ SidebarContentV2 ~ a:', layoutConfig)

	const navigation = useMemo(() => {
		return appNavigationConfig
			.map(item => {
				if (item.isWorkspace === true) {
					return currentWorkspace?.id ? item : null
				}
				return item
			})
			.filter(Boolean)
	}, [JSON.stringify(user), JSON.stringify(currentWorkspace)])

	const isDisabledMenu = useMemo(() => {
		if (currentWorkspace?.id) {
			if (currentPlan?.id) {
				return false
			}
			return true
		}
		return false
	}, [currentPlan, currentWorkspace])

	const renderNavItem = list => {
		return list.map(nav => {
			if (isFunction(nav?.checkHidden) && nav.checkHidden()) {
				return null
			}
			// if (Array.isArray(nav?.allowChannelType)) {
			// 	if (!nav?.allowChannelType.includes(currentWorkspace?.type)) {
			// 		return null
			// 	}
			// }
			if (nav.type === 'group') {
				return <MenuTypeGroup item={nav} />
			}
			if (nav.type === 'collapse') {
				return (
					<SubMenu
						className={clsx({
							'[&>.ps-submenu-content]:top-[85px]': nav.id === 'workspace' && navConfig?.collapsed,
							'[&>.ps-submenu-content]:top-[65px]': nav.id === 'personal' && navConfig?.collapsed
						})}
						defaultOpen
						key={nav.id}
						label={t(nav.title)}
						icon={<div className="text-16">{nav?.icon}</div>}
					>
						{renderNavItem(nav?.children)}
					</SubMenu>
				)
			}
			if (nav.type === 'item') {
				return <MenuTypeItem item={nav} />
			}
			if (nav.type === 'action') {
				return (
					<MenuItem
						// active={location.pathname.indexOf(nav?.link) > -1}
						key={nav.id}
						icon={nav?.icon}
						onClick={() => {
							nav?.onClick({ ...contactContext })
						}}
					>
						{t(nav?.title)}
					</MenuItem>
				)
			}
			return null
		})
	}
	const navConfig = useMemo(() => layoutConfig?.sidebar, [JSON.stringify(layoutConfig)])

	const menuItemStyles = {
		button: ({ level, active }) => {
			if (level === 0) {
				return {
					padding: '6px',
					marginLeft: 4,
					// textTransform: 'uppercase',
					fontSize: '0.9rem',
					color: '#000000b3',
					fontWeight: 600,
					'&>.ps-menu-label': {
						display: navConfig?.collapsed ? 'none' : 'inline-block'
					}
				}
			}
			if (level > 1) {
				return {
					paddingLeft: `${level * 10 + 40}px`,
					color: active ? studioColor.main_blue : 'rgb(82 82 91)',
					// color: active ? studioColor.main_blue :  '#433753',
					fontWeight: active ? 600 : 500,
					background: active ? '#EDF2FF' : 'transparent',
					borderRadius: '1rem',
					fontSize: '0.9rem',
					margin: '2px 4px',

					'&:hover': {
						background: active ? '#EDF2FF' : '#EDF2FF',
						color: active ? 'rgb(37 99 235)' : studioColor.main_blue
					},
					'&>span.ps-menu-icon': {
						// color: studioColor?.main_blue
					},
					'&>span': {
						paddingLeft: 10,
						borderLeft: '2px solid #F2F3F8',
						height: '100%',
						lineHeight: '3rem'
					}
				}
			}
			return {
				color: active ? studioColor.main_blue : 'rgb(82 82 91)',
				// color: active ? studioColor.main_blue :  '#433753',
				fontWeight: active ? 600 : 500,
				background: active ? '#EDF2FF' : 'transparent',
				borderRadius: '1rem',
				fontSize: '0.9rem',
				margin: '2px 4px',

				'&:hover': {
					background: active ? '#EDF2FF' : '#EDF2FF',
					color: active ? 'rgb(37 99 235)' : studioColor.main_blue
				},
				'&>span.ps-menu-icon': {
					// color: studioColor?.main_blue
				}
			}
		}
	}

	return (
		<div
			className={clsx('relative min-h-full flex flex-col', {
				hidden: !navConfig?.display
			})}
		>
			<Sidebar width={desktop ? '320px' : '280px'} collapsed={navConfig?.collapsed}>
				<LogoStudio collapsed={navConfig?.collapsed} />
				<Menu
					menuItemStyles={menuItemStyles}
					renderExpandIcon={status => {
						return (
							<FaSortDown
								className={clsx('mb-1 transition-all duration-300 ', {
									'rotate-0': status?.open,
									'-rotate-90': !status?.open
								})}
							/>
						)
					}}
					onClick={() => {
						if (mobile) {
							toggleOpenMobileSidebar()
						}
					}}
				>
					{renderNavItem(navigation)}
				</Menu>
			</Sidebar>
			<div
				onClick={toggleCollapse}
				className={clsx(
					'absolute p-2 -right-6 cursor-pointer top-[45%] bg-gray-100 z-[5] rounded-2xl border-2 border-[#ECEDF2] text-[1.4rem] transition-all hidden md:block   duration-300',
					{
						'rotate-180': navConfig?.collapsed
					}
				)}
			>
				<FaAngleLeft className="text-[#92949C]" />
			</div>
			{/* )} */}
			{/* <div className="absolute w-full bottom-2 left-2 right-2">
				<Typography className="w-full text-center" component="p" color="textSecondary" variant="M14">
					© EduQuiz 2022 - {new Date().getFullYear()}
				</Typography>
			</div> */}
			{!navConfig?.collapsed && (
				<Menu
					className="mt-auto"
					menuItemStyles={menuItemStyles}
					renderExpandIcon={status => {
						return (
							<FaSortDown
								className={clsx('mb-1 transition-all duration-300 ', {
									'rotate-0': status?.open,
									'-rotate-90': !status?.open
								})}
							/>
						)
					}}
					onClick={() => {
						if (mobile) {
							toggleOpenMobileSidebar()
						}
					}}
				>
					<Divider />
					{renderNavItem(footerNavigationConfig)}
					<Typography className="w-full my-3 text-center" component="p" color="textSecondary" variant="M14">
						© EduQuiz 2022 - {new Date().getFullYear()}
					</Typography>
				</Menu>
			)}
		</div>
	)
}

export default SidebarContentV2
